import React from 'react';
import { FormattedMessage } from 'react-intl';

import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import Box from '@atlaskit/primitives/box';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';

const errorContainerStyles = xcss({
	paddingLeft: 'space.100',
	paddingTop: 'space.100',
	paddingBottom: 'space.150',
	boxSizing: 'border-box',
	height: '40px',
	width: 'fit-content',
});

const errorTextStyles = xcss({
	cursor: 'default',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	color: 'color.text',
});

export const BlogTreeErrorComponent = (): React.JSX.Element => {
	return (
		<Box xcss={errorContainerStyles}>
			<Tooltip
				content={
					<FormattedMessage
						id="blog-tree.failed-to-load.tooltip"
						defaultMessage="Hold tight, we’re working on fixing this."
						description="Tooltip when hovering over blog tree error component"
					/>
				}
				position="bottom"
			>
				<Flex gap="space.050">
					<StatusErrorIcon label="error" color={token('color.icon.danger')} />
					<Box xcss={errorTextStyles}>
						<FormattedMessage
							id="blog-tree.failed-to-load.error.message"
							defaultMessage="Blog tree failed to load"
							description="Message when blog tree fails to load"
						/>
					</Box>
				</Flex>
			</Tooltip>
		</Box>
	);
};
